import { Button } from "@ui/shad"

import { useActionLink } from "@/hooks/api/action-links"
import { useEmailDialog } from "@/components/email/use-email-dialog"

interface EmailDraftProps {
  id: string
  householdId?: string
}

export default function EmailDraft({ id, householdId }: EmailDraftProps) {
  const { data: actionLink, isLoading, error } = useActionLink(id)

  const actionLinkHouseholdId =
    actionLink?.properties && typeof actionLink.properties.household_id === "string"
      ? actionLink.properties.household_id
      : undefined

  const derivedHouseholdId = householdId ?? actionLinkHouseholdId

  const { open: openEmailDialog, canSendEmail } = useEmailDialog({ householdId: derivedHouseholdId })

  const handleClick = () => {
    if (!canSendEmail) return

    if (actionLink?.properties?.syncbox_draft_id && typeof actionLink.properties.syncbox_draft_id === "string") {
      const replyToSyncboxMessageId =
        typeof actionLink.properties.reply_to_syncbox_message_id === "string"
          ? actionLink.properties.reply_to_syncbox_message_id
          : undefined
      openEmailDialog({ syncboxDraftId: actionLink.properties.syncbox_draft_id, replyToSyncboxMessageId })
    }
  }

  // Show loading state
  if (isLoading) {
    return (
      <Button variant="outline" size="sm" className="w-fit" disabled>
        Loading...
      </Button>
    )
  }

  // Show error state
  if (error) {
    console.error("Failed to load action link:", error)
    return (
      <Button variant="outline" size="sm" className="w-fit" disabled>
        Error loading draft
      </Button>
    )
  }

  // Don't render if no data
  if (!actionLink) return null

  const hasSyncboxDraft = typeof actionLink.properties?.syncbox_draft_id === "string"

  return (
    <Button
      variant="outline"
      size="sm"
      className="w-fit"
      onClick={handleClick}
      disabled={!hasSyncboxDraft || !canSendEmail}
    >
      {hasSyncboxDraft ? "View email draft" : "Message unavailable"}
    </Button>
  )
}
